import { render, staticRenderFns } from "./CustomerUserAccounts.vue?vue&type=template&id=76ac3823&scoped=true"
import script from "./CustomerUserAccounts.vue?vue&type=script&lang=ts"
export * from "./CustomerUserAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac3823",
  null
  
)

export default component.exports